export default "__VITE_ASSET__f42be6b2__"